'use client';

import { SelectChangeEvent } from '@mui/material/Select';
import { useSelector } from 'react-redux';

import { Grid, MenuItem } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '@/lib/redux/hooks';
import { RootState } from '@/lib/redux/store';
import { timeUpdated } from '@/lib/redux/features/allowed-time-slice';
import { TimeAllowedOptions } from '@/types';
import SelectComponent from '@/shared/SelectComponent';

const useAllowedTime = () => {
  const dispatch = useAppDispatch();
  const allowedTime = useSelector((state: RootState) => state.allowedTime);

  const handleChange = (event: SelectChangeEvent<unknown>) => {
    dispatch(timeUpdated(event.target.value as string));
  };

  return { allowedTime, handleChange };
};

const AllowedTime = () => {
  const { t } = useTranslation();
  const selectOptions = TimeAllowedOptions.map((m) => (
    <MenuItem key={m} value={m}>
      {t('allowed-time.minute', { count: m })}
    </MenuItem>
  ));

  const { allowedTime, handleChange } = useAllowedTime();
  return (
    <Grid container>
      <Grid display='flex' justifyContent='center' alignItems='center' size={12}>
        <SelectComponent
          selectOptions={selectOptions}
          selectedValue={allowedTime}
          formControlSx={{ m: 1, minWidth: 216 }}
          handleChange={handleChange}
          selectLabel={t('allowed-time.select-1.label-text')}
          labelId='allowedTimeSelectLabel'
          selectId='allowedTimeSelectId'
        />
      </Grid>
    </Grid>
  );
};

export default AllowedTime;
